











































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { fromEvent } from 'rxjs';

@Component({
  props: ['data', 'isAnimation', 'toTop', 'isFix', 'isProfessionals'],
})
export default class BoxMainView extends Vue {

  /**
   * ラッパー要素
   */
  private wrapper!: HTMLElement;

  /**
   * アニメーション要素
   */
  private image!: HTMLElement;

  /**
   * enタイトルSPサイズ変数
   */
  private size: string = 'auto';

  /**
   * mountedフック
   */
  public mounted(): void {
    this.wrapper = this.$refs.wrapper as HTMLElement;
    this.image = this.$refs.image as HTMLElement;
    fromEvent(window, 'scroll').subscribe((event: any): void => {
      this.image.style.height = this.wrapper.style.height = (window.innerWidth * this.$store.getters.aspect) + 'px';
      this.image.classList.add('is-fixed');

      if (window.scrollY > 10) {
        this.image.classList.add('is-blur');
      } else {
        this.image.classList.remove('is-blur');
      }
    });
    fromEvent(window, 'resize').subscribe((event: any): void => {
      this.image.style.height = this.wrapper.style.height = (window.innerWidth * this.$store.getters.aspect) + 'px';
    });
  }
}
